module.exports = __webpack_public_path__ + "img/cooperativeMedia9.75a95794.jpg";